import React, { useState } from "react";
import { Button, Modal, Tag, Tooltip } from "antd";
import { FiBell, FiBriefcase } from "react-icons/fi";
import { BiUser, BiBuilding } from "react-icons/bi";
import { BsBuilding } from "react-icons/bs";
import { messageError, messageSuccess } from "../util/AlertMessage";
import axiosJSON from "../util/Api";
import AddFeedback from "./EngineeringModule/Feedback/AddFeedback";
const titleCase = (s) =>
  s.replace(/^_*(.)|_+(.)/g, (s, c, d) =>
    c ? c.toUpperCase() : " " + d.toUpperCase()
  );
const PendingFeedbackCard = ({ feedback, getPendingFeedbackData }) => {
  const [feedbackFormOpen, setFeedbackFormOpen] = useState(false);
  const handleFeedbackFormSubmit = () => {
    getPendingFeedbackData();
    setFeedbackFormOpen(false);
  };
  return (
    <div className="pending-feedback-card">
      <div className="pending-feedback-card-upper">
        <div>
          <BiUser className="icons-consultant" />
          <span className="font-heavy-Inter mr-1">
            {feedback.consultant.name}
          </span>
          <Tooltip>
            <Tag className="round-tag">{feedback?.support_status}</Tag>
          </Tooltip>
        </div>
        <div
          onClick={() => {
            setFeedbackFormOpen(true);
          }}
          style={{
            cursor: "pointer",
            color: "var(--primary-400-base, #26305C)",
          }}
        >
          + Add Feedback
        </div>
      </div>
      <div className="pending-feedback-card-lower">
        <p>
          <BsBuilding className="icon-16" />
          <span>Client</span>
        </p>
        <p style={{ color: "var(--neutral-600, #717885)" }}>
          {feedback?.submission?.client}
        </p>
        <p>
          <BiBuilding className="icon-16" />
          <span>Vendor</span>
        </p>
        <p style={{ color: "var(--neutral-600, #717885)" }}>
          {feedback?.submission?.vendor}
        </p>
        <p>
          <FiBriefcase className="icon-16" />
          <span>Job Position</span>
        </p>
        <p style={{ color: "var(--neutral-600, #717885)" }}>
          {titleCase(feedback?.submission?.job_title)}
        </p>
      </div>
      {feedbackFormOpen ? (
        <Modal
          title="Add Supervisor's Feedback"
          visible={feedbackFormOpen}
          footer={null}
          width={900}
          className="addfeedback_popup"
          closable={false}
        >
          <AddFeedback
            project={feedback}
            project_id={feedback?.id}
            closeModal={handleFeedbackFormSubmit}
            onCancelHandle={() => {
              setFeedbackFormOpen(false);
            }}
          />
        </Modal>
      ) : null}
    </div>
  );
};
function NotifyEnginnerFeedback({
  feedbacks,
  userId,
  getPendingFeedbackData,
  count,
}) {
  const handleRemindMeLater = () => {
    const body = {
      user_id: userId,
      types: ["consultant"],
    };
    axiosJSON
      .post("/api/emp_notify/remind_me_later/", body)
      .then(({ status, data }) => {
        messageSuccess(data.message);
        getPendingFeedbackData();
      })
      .catch((err) => messageError(err));
  };
  return (
    <div>
      <p className="font-light">
        Please Add feeedback for all of your pending Project feedbacks to
        proceed
      </p>
      <div className="remind-later-div">
        <div>
          <p className="mb-1" style={{ color: "#E8930B" }}>
            Remind me later
            <Tag
              style={{ marginLeft: "5px", marginBottom: "0px" }}
              color="volcano"
            >
              {4 - count} Attempts remaining
            </Tag>
          </p>

          <span
            className="font-light"
            style={{ fontSize: "12px", color: "#1B1C20" }}
          >
            We’ll remind you to add feedback every two hours. You can delay
            feedback three times, but after that, you will be obligated to add
            feedback to continue
          </span>
        </div>
        <Button onClick={handleRemindMeLater} disabled={count > 3}>
          <FiBell />
          <p>Remind me later</p>
        </Button>
      </div>
      <div className="feedback-due-list">
        {feedbacks.map((feedback) => {
          return (
            <PendingFeedbackCard
              feedback={feedback}
              getPendingFeedbackData={getPendingFeedbackData}
            />
          );
        })}
      </div>
    </div>
  );
}

export default NotifyEnginnerFeedback;
